import Card from '../../general/card/card';
import Button from '../button/button';
import styles from './spot-rewards-cards.module.scss';

export type SpotRewardCardProps = {
  icon: string;
  title: string;
  balance: string;
  subtitle: string;
  cta?: {
    label: string;
    onClick: () => void;
    isActionEnabled: boolean;
  };
};

const SpotRewardsCard = ({
  icon,
  title,
  balance,
  subtitle,
  cta,
}: SpotRewardCardProps) => (
  <Card classString='card--hero-card' className={styles.wrapper}>
    <img src={icon} className={styles.icon} />

    <div className={styles.title}>{title}</div>

    <div className={styles.balance}>{balance}</div>

    <div className={styles.subtitle}>{subtitle}</div>

    {cta && (
      <div className={styles.cta}>
        <Button
          label={cta.label}
          onClick={cta.onClick}
          type='primary'
          disabled={!cta.isActionEnabled}
        />
      </div>
    )}
  </Card>
);

export default SpotRewardsCard;
